<script>
import ResourceList from '../../lib/components/ResourceList.vue';
import ScoreSetSelector from '../../lib/components/Selectors/ScoreSetSelector.vue';
import Archiver from '../../lib/components/ListActions/Archiver.vue';
import Unarchiver from '../../lib/components/ListActions/Unarchiver.vue';
import ListAction from '../../lib/components/ListActions/ListAction.vue';
import Tagger from '../../lib/components/ListActions/Tagger.vue';

export default {
  components: {
    ScoreSetSelector,
    Archiver,
    Unarchiver,
    ListAction,
    Tagger
  },
  extends: ResourceList,
  computed: {
    taggerRevealed() {
      return this.reveal === 'tagger';
    }
  }
};
</script>
